import { Helmet } from "react-helmet";

import TransportImage from "../assets/images/Transport.svg";

const Transport = () => {
  return (
    <main>
      <Helmet>
        <title>Transport | Provido</title>
        <meta property="og:title" content="Transport | Provido" />
        <meta
          name="description"
          content="We can help you get to appointments and attend things like day programs and community activities."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/services/transport"
        />
        <meta name="twitter:title" content="Transport | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="flex w-dvw flex-col gap-12 bg-lightblue bg-[url(./assets/images/bubblebg.webp)] px-8 py-12 md:px-24 lg:flex-row lg:gap-24 xl:px-48">
        <div className="flex items-center justify-center pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
          Transport
        </div>
        <p>
          Getting to the places that matter shouldn’t be a barrier. Our
          Transport services are designed to make travel easier, safer and more
          reliable, whether it’s a quick trip to the shops or a regular journey
          to appointments and activities.
          <br />
          <br />
          We help NDIS participants stay connected with their community, build
          independence and enjoy life on the move.
        </p>
      </div>

      {/* How We Can Help You */}
      <div className="px-6 py-16">
        <h2 className="pb-12 text-center font-display text-4xl text-purple">
          How We Can Help You
        </h2>
        <div className="mx-auto grid w-fit max-w-6xl grid-cols-1 gap-12 md:grid-cols-2">
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Everyday Travel Needs
            </h3>
            <ul className="text-list">
              <li>Transport to medical and therapy appointments</li>
              <li>
                Trips to the supermarket, shopping centres or local services
              </li>
              <li>School or day program drop-off and pick-up</li>
              <li>
                Social outings, community events or visits with friends and
                family
              </li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Assisted Travel
            </h3>
            <ul className="text-list">
              <li>Help getting in and out of the vehicle</li>
              <li>Support with mobility aids and equipment</li>
              <li>Door-to-door service for people with higher needs</li>
              <li>Escorting you to and from appointments if needed</li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Flexible Travel Options
            </h3>
            <ul className="text-list">
              <li>
                One-off trips, scheduled weekly travel or custom transport plans
              </li>
              <li>
                Use of your transport funding or travel training for increased
                independence
              </li>
              <li>Safe and clean vehicles with trained, reliable drivers</li>
            </ul>
          </div>
          <img
            src={TransportImage}
            className="w-full"
            alt="Illustration: a man driving a blue van."
          />
        </div>
      </div>

      {/* Who We Support */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-3xl text-blue lg:text-4xl">
            Who Can Access Our Transport Services?
          </h2>
          <p>
            If you’re an NDIS participant with <i>Core funding</i> in your plan,
            we can help. We support:
          </p>
          <ul className="text-list">
            <li>People with mobility or access needs</li>
            <li>
              Participants with physical, intellectual or psychosocial
              disabilities
            </li>
            <li>Children, adults and older NDIS participants</li>
          </ul>
          <p>
            We’re here to make your travel stress-free. Contact us today to
            organise a transport solution that works for you.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Transport;
